import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Suppresses errors that originate from browser extensions and third-party DOM modifications.
 * Catches:
 * 1. Errors from extension scripts (chrome-extension://, moz-extension://, etc.)
 * 2. DOM manipulation errors caused by Google Translate, antivirus extensions
 *    (Bitdefender, Norton, Kaspersky, McAfee) that inject scripts directly
 *    into the page without using extension:// URLs.
 *
 * Does NOT override console methods or DOM prototype methods.
 */
const useSilenceExtensionErrors = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp3, t0);
};
export { useSilenceExtensionErrors };
function _temp(t0) {
  const filename = t0 === undefined ? "" : t0;
  return /^(chrome|moz|safari)-extension:\/\//i.test(filename);
}
function _temp2(t0) {
  const message = t0 === undefined ? "" : t0;
  return /Failed to execute '(removeChild|insertBefore|appendChild)' on 'Node'|The node to be removed is not a child|NotFoundError:.*removeChild|Node\.removeChild.*is not a child/i.test(message);
}
function _temp3() {
  const isExtensionSource = _temp;
  const isThirdPartyDomError = _temp2;
  const handleError = e => {
    if (isExtensionSource(e.filename || "") || isThirdPartyDomError(e.message || "")) {
      e.stopImmediatePropagation?.();
      e.preventDefault?.();
      return false;
    }
  };
  const handleRejection = e_0 => {
    const stack = `${e_0.reason?.stack || ""}`;
    const message_0 = `${e_0.reason?.message || ""}`;
    if (isExtensionSource(stack) || isThirdPartyDomError(message_0)) {
      e_0.stopImmediatePropagation?.();
      e_0.preventDefault?.();
      return false;
    }
  };
  window.addEventListener("error", handleError, true);
  window.addEventListener("unhandledrejection", handleRejection, true);
  return () => {
    window.removeEventListener("error", handleError, true);
    window.removeEventListener("unhandledrejection", handleRejection, true);
  };
}